import { Button, LuIcon } from "@overmap-ai/blocks"
import { Link } from "@tanstack/react-router"
import { memo } from "react"

import { modelIconMapping } from "../../mappings/icons"
import { BaseTopBar } from "../TopBars/BaseTopBar"

export const OrganizationDocumentDetailsViewTopBar = memo(() => {
	return (
		<BaseTopBar
			leftContent={
				<Link from="/$organizationId/documents/$documentId" to="/$organizationId/documents">
					<Button variant="ghost" accentColor="base">
						<LuIcon icon={modelIconMapping.arrowLeft} />
						Documents
					</Button>
				</Link>
			}
		/>
	)
})
OrganizationDocumentDetailsViewTopBar.displayName = "OrganizationDocumentDetailsViewTopBar"
